import Entrega from "../../../views/administrador/Ventas/Entrega";




const VentasRoutes = [
  {
    path: "/Entrega",
    name: "Entrega",
    icon: "",
    component: Entrega,
    doNotShow: true,
  },
 
];

export default VentasRoutes;
